export enum EventsAndNewsVisorViews {
  CONTENT = 'CONTENT',
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
  EMPTY = 'EMPTY',
};
